import { useRouter } from "@tanstack/react-router";
import { AnchorHTMLAttributes, MouseEvent } from "react";

import { cn } from "@/lib/utils";

/** Same-app paths ("/calls/123?tab=transcript"), but not protocol-relative URLs ("//host"). */
export const isInternalHref = (href?: string): href is string =>
    Boolean(href && href.startsWith("/") && !href.startsWith("//"));

/** Links in Darwin's answers: Elitphone paths navigate in-app, anything else opens in a new tab. */
export function DarwinLink({ href, className, children, ...props }: AnchorHTMLAttributes<HTMLAnchorElement>) {
    const router = useRouter();
    const linkClassName = cn("font-medium text-primary underline underline-offset-2 hover:opacity-80", className);

    if (!isInternalHref(href)) {
        return (
            <a href={href} target="_blank" rel="noopener noreferrer" className={linkClassName} {...props}>
                {children}
            </a>
        );
    }

    const handleClick = (event: MouseEvent<HTMLAnchorElement>) => {
        // Let cmd/ctrl/shift-click open a new tab as usual
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;
        event.preventDefault();
        void router.navigate({ href });
    };

    return (
        <a href={href} onClick={handleClick} className={linkClassName} {...props}>
            {children}
        </a>
    );
}
